<template>
  <div class="modalPassword">
    <b-modal id="modalChangePassword" ref="modalChangePassword" @show="resetOnOpen" modal-class="modal-no-border modal-rename modal-radius" centered >
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <div class="btn-closeModal" @click="hideModal">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main files" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
        <h2 class="title text-center">パスワードを変更する</h2>
        <div class="text-center">
          <div class="mypage__thumbnail">
              <img v-if="editMyPage.avatar" :src="editMyPage.avatar" alt class="profile-avatar" ref="displayImage"/>
          </div>
        </div>
        <div class="form-group">
          <label for="currentPassword" class="label-form">現在のパスワード<span class="required">*</span></label>
          <div class="input-group">
            <input
              id="currentPassword"
              type="password"
              name="currentPassword"
              class="input-form"
              placeholder="現在のパスワードを入力してください"
              v-model.trim="account.currentPassword"
              :class="{error: (passwordErrors('currentPassword') == 'error') || (errorResponse.currentPassword !== '') }"
              @input="$v.account.currentPassword.$touch()"
            />
            <small v-if="!$v.account.currentPassword.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
            <small v-if="passwordErrorFormat('currentPassword')" class="text-input error">{{message.PASSWORD_FORMAT}}</small>
            <small v-if="errorResponse.currentPassword !== ''" class="text-input error">{{message.PASSWORD_INCORRECT}}</small>
          </div>
        </div>
        <div class="form-group">
          <label for="newPassword" class="label-form">新しいパスワード<span class="required">*</span></label>
          <div class="input-group">
            <input
              id="newPassword"
              type="password"
              name="newPassword"
              class="input-form"
              placeholder="新しいパスワードを入力してください"
              :class="passwordErrors('newPassword')"
              v-model.trim="account.newPassword"
              @input="$v.account.newPassword.$touch()"
            />
            <small v-if="!$v.account.newPassword.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
            <small v-if="passwordErrorFormat('newPassword')" class="text-input error">{{message.PASSWORD_FORMAT}}</small>
          </div>
        </div>
        <div class="form-group">
          <label for="confirmPassword" class="label-form">もう一度新しいパスワードを入力<span class="required">*</span></label>
          <div class="input-group">
            <input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              class="input-form"
              placeholder="もう一度パスワードを入力してください"
              v-model.trim="account.confirmPassword"
              :class="passwordErrors('confirmPassword')"
              @input="$v.account.confirmPassword.$touch()"
            />
            <small v-if="!$v.account.confirmPassword.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
            <small v-if="passwordErrorFormat('confirmPassword')" class="text-input error">{{message.PASSWORD_CONFIRM}}</small>
          </div>
        </div>
        <div class="px-2 py-2  border">
          <span class="text-center">新しいパスワードに関する注意</span>
          <ul class="list-inside">
            <li>
              <svg v-if="!newpass_containsUppercase || !newpass_containsLowercase || !newpass_containsNumber" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
              </svg>
              大文字、小文字、数字を使用してください。
            </li>
            <li>
              <svg v-if="!newpass_containsSpecial" xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
              </svg>
                少なくとも１つ以上の特殊文字（#?!@$%^&*- ）を使用してください
            </li>
            <li>
              <svg v-if="newpass_passwordLength <= 7" xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
              </svg>
              8文字以上で作成してください。
            </li>
        </ul>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <button
          class="btn btn-rounder btn-primary btn-contact "
          type="button" @click="changPassword">保存</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import {MESSAGE} from '@/utils/errorjapanese'

export default {
  name: 'ChangePassword',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      modalShow: false,
      invalid: false,
      incorrectPass: false,
      message: MESSAGE,
      checkChrome: false,
      checkFirefox: false,
      account: {},
      newpass_containsUppercase: null,
      newpass_containsLowercase: null,
      newpass_containsNumber: null,
      newpass_containsSpecial: null,
      newpass_passwordLength: 0
    }
  },
  validations: {
    account: {
      currentPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid (password) {
          const containsUppercase = /[A-Z]/.test(password)
          const containsLowercase = /[a-z]/.test(password)
          const containsNumber = /[0-9]/.test(password)
          const containsSpecial = /[#?!@$%^&*-]/.test(password)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        }
      },
      newPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid (password) {
          if (password) {
            this.newpass_containsUppercase = /[A-Z]/.test(password)
            this.newpass_containsLowercase = /[a-z]/.test(password)
            this.newpass_containsNumber = /[0-9]/.test(password)
            this.newpass_containsSpecial = /[#?!@$%^&*-]/.test(password)
            this.newpass_passwordLength = password.length
            return this.newpass_containsUppercase && this.newpass_containsLowercase && this.newpass_containsNumber && this.newpass_containsSpecial && this.newpass_passwordLength
          } else {
            this.newpass_containsUppercase = false
            this.newpass_containsLowercase = false
            this.newpass_containsNumber = false
            this.newpass_containsSpecial = false
            this.newpass_passwordLength = 0
            return false
          }
        }
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('newPassword')
      }
    }
  },
  methods: {
    passwordErrors (model) {
      if (model === 'currentPassword') {
        return (!this.$v.account.currentPassword.required || !this.$v.account.currentPassword.minLength || !this.$v.account.currentPassword.maxLength || !this.$v.account.currentPassword.valid) && this.invalid ? 'error' : ''
      }
      if (model === 'newPassword') {
        return (!this.$v.account.newPassword.required || !this.$v.account.newPassword.minLength || !this.$v.account.newPassword.maxLength || !this.$v.account.newPassword.valid) && this.invalid ? 'error' : ''
      }
      if (model === 'confirmPassword') {
        return (!this.$v.account.confirmPassword.required || !this.$v.account.confirmPassword.sameAsPassword) && this.invalid ? 'error' : ''
      }
    },
    passwordErrorFormat (model) {
      if (model === 'currentPassword') {
        return (!this.$v.account.currentPassword.minLength || !this.$v.account.currentPassword.maxLength || !this.$v.account.currentPassword.valid) && this.invalid && this.$v.account.currentPassword.required ? 'error' : ''
      }
      if (model === 'newPassword') {
        return (!this.$v.account.newPassword.minLength || !this.$v.account.newPassword.maxLength || !this.$v.account.newPassword.valid) && this.invalid && this.$v.account.newPassword.required ? 'error' : ''
      }
      if (model === 'confirmPassword') {
        return !this.$v.account.confirmPassword.sameAsPassword && this.invalid && this.$v.account.confirmPassword.required
      }
    },
    changPassword (e) {
      e.preventDefault()
      this.$store.commit('allAuth/CHANGE_INCORRECT_CURRENT_PASSWORD', {currentPassword: ''})
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('allAuth/profileChangePassword', this.account)
    },
    resetOnOpen () {
      if (this.$v.$anyError) {
        this.invalid = false
        this.$nextTick(() => { this.$v.$reset() })
      }
      this.account = {}
      this.$store.commit('allAuth/SET_SUCCESS_FLAG', false)
      this.$store.commit('allAuth/CHANGE_INCORRECT_CURRENT_PASSWORD', {currentPassword: ''})
    },
    hideModal () {
      this.$bvModal.hide('modalChangePassword')
    }
  },
  computed: {
    ...mapState({
      errorResponse: state => state.allAuth.errorMessage,
      isSuccess: state => state.allAuth.isSuccess,
      editMyPage: state => state.allAuth.editMyPage
    })
  },
  watch: {
    isSuccess (newValue, oldValue) {
      if (newValue) {
        setTimeout(() => {
          this.$bvModal.hide('modalChangePassword')
        }, 700)
      }
    }
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/auth/listfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
.mr-30{
  margin-right: 30px;
}
.mw-253{
  max-width: 253px;
}
</style>



// WEBPACK FOOTER //
// src/components/share/ChangePassword.vue